import React from 'react'
import { bool, func, number, string, oneOfType } from 'prop-types'
import styled from 'styled-components'

const StyledSVG = styled.svg`
  fill: ${({ fillColor }) => fillColor};
  stroke: ${({ strokeColor }) => strokeColor};
`

export function LinkOut({ ariaHidden, stroke, fill, focusable, height, title, width, ...rest }) {
  const w = width || '1rem'
  const h = height || '1rem'

  return (
    <StyledSVG
      viewBox='0 0 12 12'
      width={w}
      height={h}
      aria-hidden={ariaHidden}
      focusable={focusable}
      fillColor={fill}
      strokeColor={stroke}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <g stroke='none'>
        <path d='M11.0173 6.59866C10.9388 6.59866 10.8743 6.62381 10.8242 6.67434C10.7737 6.72458 10.7485 6.78896 10.7485 6.86737V9.55449C10.7485 9.92399 10.6171 10.2402 10.354 10.5034C10.0909 10.7665 9.77454 10.8979 9.40504 10.8979H2.41838C2.0489 10.8979 1.73258 10.7665 1.46943 10.5034C1.20634 10.2403 1.0748 9.92402 1.0748 9.55449V2.56792C1.0748 2.19844 1.20631 1.88223 1.46943 1.61911C1.73258 1.35596 2.0489 1.22446 2.41838 1.22446L5.26189 1.22446C5.34039 1.22446 5.4048 1.1992 5.45512 1.14887C5.50545 1.09849 5.53059 1.03417 5.53059 0.955725V0.41822C5.53059 0.339925 5.50545 0.275483 5.45512 0.225188C5.4048 0.174806 5.34039 0.149658 5.26189 0.149658L2.41838 0.149658C1.75225 0.149658 1.1826 0.38619 0.709478 0.859224C0.236532 1.33223 0 1.90188 0 2.56801V9.5546C0 10.2207 0.236532 10.7904 0.709507 11.2633C1.18263 11.7364 1.75228 11.973 2.41841 11.973H9.40504C10.0711 11.973 10.6408 11.7364 11.1139 11.2633C11.587 10.7904 11.8235 10.2207 11.8235 9.5546V6.86758C11.8235 6.78908 11.7984 6.72466 11.7478 6.67434C11.6974 6.62381 11.633 6.59866 11.5547 6.59866H11.0173Z' />
        <path d='M11.2259 0.235352H6.92651C6.78098 0.235352 6.65495 0.288499 6.54866 0.394881C6.44228 0.501205 6.38901 0.627175 6.38901 0.772734C6.38901 0.918293 6.44228 1.04429 6.54866 1.15068L8.02651 2.62856L4.084 6.43908C4.02794 6.49505 4 6.55947 4 6.63211C4 6.70503 4.02803 6.76941 4.084 6.82538L5.04129 7.78255C5.09726 7.83853 5.16168 7.86644 5.23444 7.86644C5.30721 7.86644 5.37165 7.83855 5.42759 7.78255L9.37013 3.97212L10.8481 5.45C10.9544 5.55638 11.0804 5.60959 11.226 5.60959C11.3715 5.60959 11.4975 5.55638 11.6039 5.45C11.7103 5.34365 11.7635 5.2177 11.7635 5.07215V0.772734C11.7634 0.627087 11.7101 0.501205 11.6038 0.394881C11.4974 0.288499 11.3713 0.235352 11.2259 0.235352Z' />
      </g>
    </StyledSVG>
  )
}

LinkOut.defaultProps = {
  ariaHidden: false,
  focusable: false,
  stroke: '#000',
  fill: '#000',
}

LinkOut.propTypes = {
  ariaHidden: bool,
  stroke: oneOfType([string, func]),
  fill: oneOfType([string, func]),
  focusable: bool,
  height: number,
  title: string,
  width: number,
}
